import { TransactionStepProvider } from "../transaction/new-transaction/transaction-step.context";
import { NewSubscriptionProvider } from "./new-subscription.context";
import NewSubscription from "./new-subscription/new-subscription";

export function NewSubscriptionWrapper() {
  return (
    <TransactionStepProvider>
      <NewSubscriptionProvider>
        <NewSubscription />
      </NewSubscriptionProvider>
    </TransactionStepProvider>
  );
}

export default NewSubscriptionWrapper;
